import { render, staticRenderFns } from "./TextConfig.vue?vue&type=template&id=faa61b12&scoped=true"
import script from "./TextConfig.vue?vue&type=script&lang=js"
export * from "./TextConfig.vue?vue&type=script&lang=js"
import style0 from "./TextConfig.vue?vue&type=style&index=0&id=faa61b12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faa61b12",
  null
  
)

export default component.exports